import * as Yup from "yup";

import {
  CreateAutoFacConfiguration,
  CreateAutoFacConfigurationVariables,
} from "_graphql/mutation/__generated__/CreateAutoFacConfiguration";
import { Modal, OfficeButton } from "components";

import { AutoFacConfigForm } from "components/forms";
import { createAutoFacConfiguration } from "_graphql/visal/mutations/auto-fac";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required")
});

export default function CreateAutoFacContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const [execute, { loading }] = useMutation<
    CreateAutoFacConfiguration,
    CreateAutoFacConfigurationVariables
  >(createAutoFacConfiguration, {
    refetchQueries: ["GetAutoFacConfig"],
  });

  const form = useFormik<CreateAutoFacConfigurationVariables>({
    initialValues: {
      name: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (variables, helpers) => {
      execute({ variables })
        .then(() => {
          toast.success("Auto Fac Configuration fcreated successfully");
          setOpen(false);
          helpers.resetForm();
          refetch && refetch();
        })
        .catch((err) => {
          toast.error(err.message);
        });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      // size="4xl"
      title="Create Auto Fac"
      description="provide the details of the Auto Fac below"
      renderActions={() => (
        <>
          <OfficeButton
            type="button"
            size="sm"
            disabled={loading}
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Please wait ..." : "Create Auto Fac Configuration"}
          </OfficeButton>
        </>
      )}
    >
      <AutoFacConfigForm form={form} />
    </Modal>
  );
}
